import { CommonModule } from "@angular/common";
import { Component, Input} from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { Customer } from "src/app/models/customer.model";
import { CustomerService } from "src/app/services/customer.service";

@Component({
    selector: "customer-details-general-data-component",
    templateUrl: "./customer-details-general-data.component.html",
    styleUrls: ["./customer-details-general-data.component.scss"],
    imports: [ButtonModule, CardModule, CommonModule],
    providers: [CustomerService]
})
export class CustomerDetailsGeneralDataComponent {
    @Input() customer!: Customer;   
}
